export const MobilityFormSelf = {
  title: 'Mobility',
  formVersion: 1,
  description: 'Client Mobility Intake Form',
  formKey: 'CLIENT_MOBILITY_INTAKE_FORM',
  questions: {
    'Mobility-tasks': {
      questionId: 'Mobility-tasks',
      fieldType: 'checkbox',
      rank: 1,
      questionData: {
        label: 'What mobility tasks do you need help with?',
        helpText: '',
        required: true,
      },
      options: [
        {value: 'walking-support', label: 'Walking support', isOther: false},
        {value: 'standing', label: 'Standing up or sitting down', isOther: false},
        {value: 'transferring', label: 'Transferring', isOther: false},
        {value: 'repositioning', label: 'Turning or repositioning in bed', isOther: false},
        {value: 'stairs', label: 'Managing stairs', isOther: false},
        {value: 'fall-prevention', label: 'Fall prevention', isOther: false},
        {value: 'other', label: 'Other', isOther: true},
      ],
    },
    'Mobility-equipment': {
      questionId: 'Mobility-equipment',
      fieldType: 'checkbox',
      rank: 2,
      questionData: {
        label: 'What mobility equipment do you use?',
        helpText: '',
        required: false,
      },
      options: [
        {value: 'walker', label: 'Walker', isOther: false},
        {value: 'wheelchair', label: 'Wheelchair', isOther: false},
        {value: 'cane', label: 'Cane', isOther: false},
        {value: 'hospital-bed', label: 'Hospital bed', isOther: false},
        {value: 'transfer-belt', label: 'Transfer belt (gait belt)', isOther: false},
        {value: 'lift', label: 'Hoyer lift or other lifting device', isOther: false},
        {value: 'other', label: 'Other', isOther: true},
      ],
    },
    'Mobility-assistance-level': {
      questionId: 'Mobility-assistance-level',
      fieldType: 'radio',
      rank: 3,
      questionData: {
        label: 'What level of physical assistance do you need?',
        helpText: '',
        required: true,
      },
      options: [
        {value: 'supervision', label: 'Supervision only', isOther: false},
        {value: 'light', label: 'Light hands-on support', isOther: false},
        {value: 'moderate', label: 'Moderate support', isOther: false},
        {value: 'full', label: 'Full support', isOther: false},
        {value: 'other', label: 'Other', isOther: true},
      ],
    },
  },
};
